//Library Imports
import { Button, Dropdown, Menu, Tooltip } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "store";

//Local Imports
import { CONTENT_ANALYTICS } from "constants/types";
import Search from "./Search";

interface IContactEmailDropdown {
  emailsCount: number;
  items: any[];
  articleId: number;
}

const ContactEmailDropdown: React.FC<IContactEmailDropdown> = (props: IContactEmailDropdown) => {
  //Props
  const { items, emailsCount, articleId } = props;

  //Local States
  const [ellipsisState, setEllipsistate] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  //Redux States
  const searchedText = useSelector((state: RootState) => state.analyticsContent.emailSearchValue);
  const searchedData = useSelector((state: RootState) => state.analyticsContent.searchedData);

  const setSearchValue = (searchValue?: string) => {
    store.dispatch({
      type: CONTENT_ANALYTICS.SET_SEARCH,
      payload: { searchValue: searchValue, articleId: articleId },
    });
  };

  const menu = () => (
    <Menu>
      <div className="email-container">
        <div className="sub-header">
          <Search
            placeholder="Search"
            handleSearch={setSearchValue}
            reset={searchedText}
            isVisible={isVisible}
          ></Search>
        </div>
        <div className="email-list">
          {searchedText !== "" && searchedData.length <= 0 ? (
            <div style={{ textAlign: "center" }}>No data found.</div>
          ) : searchedData.length > 0 ? (
            Object.values(searchedData).map((item: any) => (
              <Tooltip placement="top" title={ellipsisState ? item.contactEmail : undefined}>
                <div className="item-email">
                  <span className="click-email">{item.contactEmail}</span>
                  <span className="click-count">({item.clickCount})</span>
                </div>
              </Tooltip>
            ))
          ) : (
            Object.values(items).map((item: any) => (
              <Tooltip placement="top" title={item.contactEmail}>
                <div className="item-email">
                  <span className="click-email">{item.contactEmail}</span>
                  <span className="click-count">({item.clickCount})</span>
                </div>
              </Tooltip>
            ))
          )}
        </div>
      </div>
    </Menu>
  );
  return (
    <Dropdown
      overlay={menu}
      placement="bottomRight"
      trigger="click"
      overlayClassName="dropdown-checked-by"
      onVisibleChange={(visible: boolean) => {
        setIsVisible(visible);
      }}
      visible={isVisible}
    >
      <Button className="email-btn" data-clicked="clicked-by-dropdown">
        {emailsCount}
        <span className="ant-select-arrow" unselectable="on" aria-hidden="true" style={{ userSelect: "none" }}>
          <span role="img" aria-label="down" className="anticon anticon-down ant-select-suffix">
            <svg
              viewBox="64 64 896 896"
              focusable="false"
              data-icon="down"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path>
            </svg>
          </span>
        </span>
      </Button>
    </Dropdown>
  );
};

export default ContactEmailDropdown;
